module.exports = __webpack_public_path__ + "static/media/result_rs_ja.fa18d532.jpg";